export default "__VITE_PUBLIC_ASSET__2c643fa1__"